import { useQuery } from '@tanstack/react-query';
import { useActivePage } from '@toolpad/core';
import { useParams } from 'react-router';
import { Stack } from '@mui/material';

import { QueryRenderer } from '@barboxx/admin-components';
import Api from '@barboxx/api';
import { Can } from '@barboxx/react-utils';

import { RootContainer } from '../../components/nav/RootContainer';
import { CategoriesListCard } from './components/CategoriesListCard';
import { PourFormatListCard } from './components/PourFormatListCard';
import { RecipeItemListCard } from './components/RecipeItemListCard';
import { StandardDrinkDeleteCard } from './components/StandardDrinkDeleteCard';
import { StandardDrinkDetailsCard } from './components/StandardDrinkDetailsCard';
import { SubstitutionsListCard } from './components/SubstitutionsListCard';

export function StandardDrinkDetails() {
    const { id } = useParams();
    const activePage = useActivePage();

    const standardDrinkQueryResults = useQuery({
        queryKey: ['standardDrink', id],
        queryFn: () =>
            Api.StandardDrinks.StandardDrink.getStandardDrink(Number(id)),
    });

    const breadcrumbs = [
        ...(activePage?.breadcrumbs ?? []),
        {
            title: 'Details',
            path: `${activePage?.path}/${id}`,
        },
    ];

    return (
        <RootContainer maxWidth="lg" breadcrumbs={breadcrumbs}>
            <QueryRenderer results={standardDrinkQueryResults}>
                {data => {
                    return (
                        <Stack gap={2} sx={{ paddingBottom: 4 }}>
                            <StandardDrinkDetailsCard standardDrink={data} />
                            <RecipeItemListCard
                                standardDrink={data}
                                refetch={standardDrinkQueryResults.refetch}
                            />
                            <CategoriesListCard
                                standardDrink={data}
                                refetch={standardDrinkQueryResults.refetch}
                            />
                            <SubstitutionsListCard
                                standardDrink={data}
                                refetch={standardDrinkQueryResults.refetch}
                            />
                            <PourFormatListCard
                                standardDrink={data}
                                refetch={standardDrinkQueryResults.refetch}
                            />

                            {!data.categories.length && (
                                <Can I="delete" a="StandardDrink">
                                    <StandardDrinkDeleteCard
                                        standardDrink={data}
                                    />
                                </Can>
                            )}
                        </Stack>
                    );
                }}
            </QueryRenderer>
        </RootContainer>
    );
}
